import { useState, useEffect } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Avatar,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core';
import getInitials from 'src/utils/getInitials';
const CustomerListResults = ({ customers, ...rest }) => {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const handleLimitChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Wallet ADD</TableCell>
                  <TableCell>User Name</TableCell>
                  <TableCell>User status</TableCell>
                  <TableCell>Register day</TableCell>
                  <TableCell>Wallet value</TableCell>
                  <TableCell>Created items</TableCell>
                  <TableCell>Sale-on items</TableCell>
                  <TableCell>Bought items</TableCell>
                  <TableCell>Sold items</TableCell>
                  <TableCell>More</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((customer, idx) => (
                    <TableRow hover key={customer.id}>
                      <TableCell>{customer.address}</TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <Avatar src={customer.avatar.String} sx={{ mr: 2 }}>
                            {getInitials(customer.name)}
                          </Avatar>
                          <Typography color="textPrimary" variant="body1">
                            {customer.username.String}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {customer.status === 0 ? "Active" : "Blocked"}
                      </TableCell>
                      <TableCell>----</TableCell>
                      <TableCell>----</TableCell>
                      <TableCell>----</TableCell>
                      <TableCell>----</TableCell>
                      <TableCell>----</TableCell>
                      <TableCell>----</TableCell>
                      <TableCell>
                        <a href={`/app/dashboard?id=${customer.address}`}>
                          More
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={customers.length}
        onChangePage={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5]}
      />
    </Card>
  );
};

CustomerListResults.propTypes = {
  customers: PropTypes.array.isRequired
};

export default CustomerListResults;
